// extracted by mini-css-extract-plugin
module.exports = {"footer":"StrrtrmFooter_footer__vuhgE","button":"StrrtrmFooter_button__3grMy"};